import { render, staticRenderFns } from "./SpecialLinkSidebar.vue?vue&type=template&id=588e225a&"
import script from "./SpecialLinkSidebar.vue?vue&type=script&lang=js&"
export * from "./SpecialLinkSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports